import { Navigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { isNational } from "@/lib/perms";
import { usePageTitle } from "@/components/layout/AppLayout";
import { PageHead } from "@/pages/admin/AdminLayout";
import { AnalyticsFilters } from "@/components/admin/AnalyticsFilters";
import { AnalyticsPanel } from "@/components/admin/AnalyticsPanel";
import { AccessLog } from "@/components/admin/AccessLog";
import { ReportButtons } from "@/components/admin/ReportButtons";

export default function AnalyticsPage({ view = "analytics" }) {
    const registro = view === "registro";
    usePageTitle(registro ? "Registro accessi" : "Analytics");
    const { user } = useAuth();
    const isSuper = isNational(user);
    const [params] = useSearchParams();
    if (!registro && params.get("vista") === "registro") return <Navigate to="/amministrazione/registro" replace />;
    const scope = isSuper ? "nazionale" : `· ${user.spin?.name || "sede"}`;
    return (
        <>
            <PageHead title={`${registro ? "Registro accessi" : "Analytics"} ${scope}`} />
            <AnalyticsFilters isSuper={isSuper} />
            <div className="mb-4">{registro ? <ReportButtons key="r" section="registro" /> : <ReportButtons key="a" section="analytics" drop={["tipo", "q"]} />}</div>
            {registro ? <AccessLog /> : <AnalyticsPanel isSuper={isSuper} />}
        </>
    );
}
